// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-base__oWu2i{display:flex;gap:var(--size-2);align-items:center;width:100%}.Header-idGroup__h1I1Q{display:flex;flex:1 0 0;gap:var(--size-1_5);align-items:center;min-width:0}.Header-id__ylRq_{font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400);flex:0 1 auto;min-width:0;color:var(--text-subtle)}.Header-idPlaceholder__YFOb0{color:var(--text-placeholder)}.Header-separator__ujOw6{flex-shrink:0}.Header-subId__iTXMM{flex:0 1000 auto}.Header-seenIcon__VYVTN{flex-shrink:0;color:var(--gray-a9)}.Header-statusSlot__e5lEz{flex-shrink:0}.Header-idSkeleton__vd92B{flex:1 0 0;min-width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "Header-base__oWu2i",
	"idGroup": "Header-idGroup__h1I1Q",
	"id": "Header-id__ylRq_",
	"idPlaceholder": "Header-idPlaceholder__YFOb0",
	"separator": "Header-separator__ujOw6",
	"subId": "Header-subId__iTXMM",
	"seenIcon": "Header-seenIcon__VYVTN",
	"statusSlot": "Header-statusSlot__e5lEz",
	"idSkeleton": "Header-idSkeleton__vd92B"
};
export default ___CSS_LOADER_EXPORT___;
